import { useEffect, useState } from 'react'

import { authHeader } from '../../api/'
import { refreshToken } from '../auth/'

const { REACT_APP_API_URL } = import.meta.env

export const useSensorCalculations = (month, year, limit = 50, offset = 1) => {
  const [data, setData] = useState(null)
  const [isError, setError] = useState(null)
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    if (!month || !year) return
    ;(async () => {
      setLoading(true)
      setError(null)
      try {
        await refreshToken()

        const url = `${REACT_APP_API_URL}/sensors/admin/v2-sensors-calculations/?month=${month}&year=${year}&limit=${limit}&offset=${offset}`
        const options = { headers: { ...authHeader() }, method: 'GET' }
        const response = await fetch(url, options)
        if (!response.ok) {
          const text = await response.text()
          throw new Error(text || `HTTP ${response.status}`)
        }

        const payload = await response.json()
        setData(payload)
      } catch (error) {
        setError(error?.message || 'V2 Sensor Calculations: Fehler')
      } finally {
        setLoading(false)
      }
    })()
  }, [month, year, limit, offset])

  return { data, isError, isLoading }
}
